module.exports = __webpack_public_path__ + "img/2.37dfc1f4.jpg";